import { render, staticRenderFns } from "./CarRepair.vue?vue&type=template&id=f01bedf4&scoped=true&"
import script from "./CarRepair.vue?vue&type=script&lang=js&"
export * from "./CarRepair.vue?vue&type=script&lang=js&"
import style0 from "./CarRepair.vue?vue&type=style&index=0&id=f01bedf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01bedf4",
  null
  
)

export default component.exports